import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { PrintService } from 'src/app/services/print.service';
import { TABS } from 'src/app/dummy/tab';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { GrammarSectionFormComponent } from '../grammar-section-form/grammar-section-form.component';
import { GrammarInUseStore } from 'src/app/stores/resources/grammarInUse';

@Component({
  selector: 'app-grammar-lesson',
  templateUrl: './grammar-lesson.component.html',
  styleUrls: ['./grammar-lesson.component.scss']
})
export class GrammarLessonComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs: any = TABS.PROGRAM_LEVEL;
  LESSON_KEY: any;
  ITEM: any = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public store: GrammarInUseStore,
    private auth: AuthStore,
    public ps: PrintService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(async (param) => {
      this.LESSON_KEY = param['id'];
      this.tabs = TABS.GRAMMAR_IN_USE_LESSON.map(m => ({ path: `/grammar-in-use/lesson/${this.LESSON_KEY}`, label: m.label }))
      this.ITEM = await this.store.fetchSelectedLesson(this.LESSON_KEY)
      if (!this.ITEM) {
        this.router.navigate([`/404`])
        return;
      }
      this.store.fetchGrammarInUse(true);
    })
  }

  addItem(item: any) {
    this.router.navigate([`/grammar-in-use/grammar-in-use-section/${this.ITEM.key}/${item ? item.key : 'draft'}`])
  }


  delete(item: any) {
    let dialogRef = this.dialog.open(DeleteComponent, {
      data: item,
      panelClass: 'cs-overlay-panel',
      width: '',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        // this.store.delete(COLLECTION_NAME.LEVEL, item, (success) => {
        //   if (success) {
        //     this.snackBar.open("Level has been deleted successful.", "Done", { duration: 2500 });
        //   }
        // })
      }
    });
  }
}
